import styled from 'styled-components';
import Checkbox from 'antd/es/checkbox';

export const StyledCheckbox = styled(Checkbox)`
  &&& {
    margin-top: 10px;
  }
`;
